<script>
import {getAllArea} from "@/api/device-manager-api";
import {getApplyLisByGateCardNo, getApplyListByPinCode, getApplyListByVisitCode, getBookForm} from "@/api/apply-api";
import {addVisitor, getVisitorByBatch, searchVisitor} from "@/api/visitor-api";
import {aesDec} from "@/utils/cryptoUtils";
import {getRecordList, getTodayEnterRecord} from "@/api/record-api";
import {Apply, Record} from "@/entity/entity";
import {guard_mixin} from "@/pages/guard/guard_mixin";
import {usual_visitor_sign_mixin} from "@/pages/helper/usual_visitor_mixin";
import RemarkInputView from "@/pages/guard/RemarkInputView.vue";
import CarKeyboard from "@/components/carkeyboard/CarKeyboard.vue";

export default {
  name: "RegisterFormView",
  components: {RemarkInputView, CarKeyboard},
  props: ["visitorSetting", "guardSignConfig"],
  mixins: [guard_mixin, usual_visitor_sign_mixin],
  data() {
    return {
      visitor: null,
      mainVisitor: null,
      visitorForm: {
        name: "",
        tel: "",
        ic: "",
        nationality: "中国", // 默认中国
        company: "",
        extCardNo: "",
        qrCode: "",
      },
      visitorRules: {
        name: [{required: true, message: "请输入访客姓名", trigger: 'blur'}],
        tel: [
          {required: true, message: "请输入访客手机号", trigger: 'blur'},
          {type: 'string', max: 11, message: '手机号长度不能超过11位'},
          {type: 'string', pattern: /^[1][0-9]{10}$/, message: '请输入正确的手机号', trigger: 'blur'}],
        company: [{required: true, message: "请输入访客公司", trigger: 'blur'}],
      },
      visitorDisable: false,

      forms: [],
      originForms: [],
      formItemCar: null,
      applyForm: {},
      applyRules: {},
      applyDisable: false,

      extFormData: {
        visitorNumber: "1",
        guardSign: "",
        enterCarNum: "",
        comments: "",
      },
      extFormRules: {
        visitorNumber: [{required: true, message: "请输入访客人数 ", trigger: 'change'}],
        guardSign: [{required: true, message: "请选择保安签名", trigger: "change"}],
      },

      guardSignShow: true,
      guardSignRequired: true,
      extDisable: false,

      areaData: {
        areaLeave1: [],
        areaVerifySwitch: false,
      },

      curGateId: "",
      curAreaIds: [],

      recordDialog: {
        show: false,
        hasEnterRecord: false,
        recordList: [],
        visitor: null,
      },
      applyDialog: {
        show: false,
        applyList: [],
        visitor: null,
      },
      signOutTime: "",

      isRegister: true,

      carVisible: false,
    }
  },

  mounted() {
    this.updateGuardSignConfig()
    let curGateId = this.$store.state.loginInfo.areaId
    getAllArea().then(({data}) => {
      if (data.code === 200) {
        this.areaData.areaLeave1 = data.data
        data.data.forEach((item) => {
          item.value = item.id
          item.label = item.name
          item.children = item.areas
          item.children.forEach((item2) => {
            item2.value = item2.id
            item2.label = item2.name
            if (curGateId === item2.id) {
              this.curAreaIds = (item.areas || []).map(item3 => item3.id)
            }
          })
        })
      }
    })
    getBookForm().then(({data}) => {
      console.log("getBookForm", data)
      if (data.code === 200) {
        data.data.formItems.forEach((item) => {
          if (item.valueList) {
            item.valueListParse = JSON.parse(item.valueList)
            if (item.required) {
              this.applyRules[item.name] = [{required: true, message: '必填项', trigger: 'blur'}]
            } else {
              this.applyRules[item.name] = [{required: false}]
            }
          }
          // 开始时间
          if (item.type === "accompany") {
            this.hasPeer = true
          } else if (item.type === 'beginTime' || item.type === 'endTime') {
            // 开始时间，结束时间取现在，不展示表单
          } else if (item.type === 'car') {
            this.formItemCar = item
          } else {
            this.forms.push(item)
          }
        })
        this.originForms = data.data.formItems
        this.$nextTick(() => {
          // this.$refs.visitorCardNo 获取焦点
          this.$refs.visitorCardNo.focus()
        })
      }
    })

    if (this.visitorSetting.nationality === 3) {
      this.visitorRules.nationality = [{required: true, message: "请输入访客国籍", trigger: 'blur'}]
    }
    if (this.visitorSetting.idCardNo === 3) {
      this.visitorRules.ic = [{required: true, message: "请输入访客身份证号", trigger: 'blur'}]
    }
  },

  methods: {
    updateGuardSignConfig() {
      let config = this.guardSignConfig || 3
      this.guardSignShow = config !== 1
      this.guardSignRequired = config === 3
      if (this.guardSignShow) {
        if (this.guardSignRequired) {
          this.$set(this.extFormRules, 'guardSign', [{required: true, message: "请选择保安签名", trigger: "change"}])
        } else {
          this.$set(this.extFormRules, 'guardSign', [])
        }
      } else {
        this.$set(this.extFormRules, 'guardSign', [])
        this.extFormData.guardSign = ""
      }
    },

    async getMainVisitor() {
      if (this.visitor) {
        this.visitor.extCardNo = this.visitorForm.extCardNo
        return this.visitor
      }
      let postData = {
        name: this.visitorForm.name,
        tel: this.visitorForm.tel,
        ic: this.visitorForm.ic,
        company: this.visitorForm.company,
        nationality: this.visitorForm.nationality,
        type: 'common'
      }
      let res = await addVisitor(postData)
      this.visitor = res.data.data
      this.visitor.extCardNo = this.visitorForm.extCardNo
      return this.visitor
    },

    getFormItems() {
      let result = []
      this.forms.forEach(item => {
        if (item.type !== 'beginTime' && item.type !== 'endTime') {
          item.value = this.applyForm[item.name]
        }
        if (item.type !== 'myAddress') {
          result.push(item)
        }
        if (this.formItemCar && this.extFormData.enterCarNum) {
          if (this.extFormData.enterCarNum) {
            this.formItemCar.value = this.extFormData.enterCarNum
          } else {
            this.formItemCar.value = ''
          }
          result.push(this.formItemCar)
        }
      })
      return result
    },

    onSelectChange(item, valueList, selectValue) {
      console.log("onSelectChange1", item)  //
      console.log("onSelectChange2", valueList)
      console.log("onSelectChange3", selectValue)
      // 字段依赖回填有bug ， 待优化 ， 先不处理字段依赖
      if (item.valueSelect && item.valueSelect.dependField) {
        this.dealDependFieldRemove(item.valueSelect)
      }
      item.valueSelect = null

      let find = valueList.find(subItem => subItem.value === selectValue)
      console.log("@@@@ find", find)
      if (find && (find.dependField || find.isReadyOnly)) {
        this.dealDependFieldAdd(find)
        item.valueSelect = find
      }
    },

    dealDependFieldRemove(selectValue) {
      if (selectValue.signOutTime) {
        this.signOutTime = ""
      }
      let formItemTarget = this.forms.find(formItem => {
        return formItem.id === selectValue.dependField
      });

      if (formItemTarget) {
        this.$set(formItemTarget, "extRequired", 0)

        let requiredValue
        if (formItemTarget.required) {
          requiredValue = [{required: true, message: '必填项', trigger: 'blur'}]
        } else {
          requiredValue = [{required: false}]
        }
        this.$set(this.applyRules, formItemTarget.name, requiredValue)

        if (selectValue.isReadyOnly) {
          this.$set(formItemTarget, "extIsReadyOnly", false)
          this.$set(this.applyForm, formItemTarget.name, "")
        }
      }
    },

    // 处理依赖字段添加
    dealDependFieldAdd(selectValue) {
      if (selectValue.signOutTime) {
        this.signOutTime = selectValue.signOutTime
      }
      let formItemTarget = this.forms.find(formItem => {
        return formItem.id === selectValue.dependField
      });
      if (formItemTarget) {
        formItemTarget.extRequired = 1
        this.applyRules[formItemTarget.name] = [{required: true, message: '必填项', trigger: 'blur'}]

        if (selectValue.isReadyOnly) {
          this.$set(formItemTarget, "extIsReadyOnly", true)
          this.$set(this.applyForm, formItemTarget.name, selectValue.readyValue)
        }
      }
    },

    onVisitorSelectChange(selectVisitorList) {
      let count = selectVisitorList.length
      if (this.isRegister) {
        this.extFormData.visitorNumber = count + 1
      } else {
        this.extFormData.visitorNumber = count
      }
    },

    searchCardNo() {
      if (this.visitorForm.extCardNo === "") {
        return
      }
      this.doSearch({visitorCardNo: this.visitorForm.extCardNo}, false)
    },

    searchQrCode() {
      if (this.visitorForm.qrCode === "") {
        return
      }
      let str = this.visitorForm.qrCode
      if (str.length === 8 && !isNaN(str)) {
        this.doSearch({visitorPinCode: str}, false)
      } else {
        this.doSearch({visitorSignCode: str}, false)
      }
    },
    searchPhoneNo(phoneNo) {
      this.doSearch({phoneNo: phoneNo}, true)
    },

    searchIcCardNo(icCardNo) {
      this.doSearch({icCardNo: icCardNo}, true)
    },

    async getVisitor(searchObj) {
      if (searchObj.phoneNo || searchObj.icCardNo) {
        let searchData = {
          tel: searchObj.phoneNo,
          ic: searchObj.icCardNo
        }
        let res = await searchVisitor(searchData)
        if (res.data.code === 200 && res.data.data.length > 0) {
          return res.data.data[0]
        } else {
          return null
        }
      } else if (searchObj.visitorSignCode) {
        try {
          let jsonResult = aesDec(searchObj.visitorSignCode)
          let data = JSON.parse(jsonResult)
          let code = data.code
          let res = await getVisitorByBatch([code])
          if (res.data.code === 200 && res.data.data.length > 0) {
            return res.data.data[0]
          } else {
            return null
          }
        } catch (err) {
          console.log("parse error", err)
          return null
        }
      }
    },

    async getRecord(searchObj, visitor) {
      if (!searchObj.visitorPinCode && !searchObj.visitorCardNo && !visitor) {
        return null
      }
      let postData = {
        visitorCode: visitor ? visitor.code : null,
        pinCode: searchObj.visitorPinCode,
        cardNo: searchObj.visitorCardNo,
        history: true,
        enterAreaIds: this.curAreaIds
      }

      let res = await getTodayEnterRecord(postData)
      if (res.data.code === 200 && res.data.data.length > 0) {
        return res.data.data
      } else {
        return null
      }
    },

    onGetRecord(recordList, visitor) {
      console.log("onGetRecord", recordList)
      //
      this.recordDialog = {
        show: true,
        hasEnterRecord: false,
        recordList: [],
        visitor: visitor
      }
      recordList.forEach(item => {
        this.recordDialog.recordList.push({
          myTag: this.getRecordTag(item),
          myVisitorName: item.pinVisitor ? item.pinVisitor.name : item.visitor.name,
          myEmployeeName: item.employee ? item.employee.name : "",
          myEnterTime: item.enterDate + " " + item.enterTime.substring(0, 5),
          myLeaveTime: item.leaveDate ? item.leaveDate + " " + item.leaveTime.substring(0, 5) : "",
          completeState: item.completeState,
          data: item
        })
        this.recordDialog.hasEnterRecord = true
      })
    },

    getRecordTag(record) {
      if (record.type === "USUAL") {
        return "常访访客"
      } else if (record.apply) {
        switch (record.apply.type) {
          case 'BOOK_APPLY':
            return "访客预约"
          case 'INVITE_APPLY':
            return "员工邀约"
          case 'SCENE_APPLY':
            if (record.apply.device === 'web') {
              return "现场登记"
            } else {
              return "自助登记"
            }
        }
      }
      return "员工邀约"
    },

    doChooseRecord(record) {
      console.log("doChooseRecord", record)
      this.isRegister = false
      this.recordDialog.show = false
      this.applyDisable = true
      this.visitorDisable = true
      this.extDisable = true
      let recordObj = new Record(record)
      if (recordObj.type !== "USUAL") {
        let formList = recordObj.apply.getShowFormList()
        formList.forEach(item => {
          let find = this.originForms.find(originItem => originItem.title === item.label)
          if (find) {
            this.$set(this.applyForm, find.name, item.value)
          }
        })
        this.mainVisitor = recordObj.apply.visitor
      }
      let visitor = record.visitor

      this.extFormData.enterCarNum = record.enterCarNum
      this.extFormData.comments = record.comments

      let extCardNo = record.enterCardNo
      this.visitor = visitor
      this.visitorForm = {...visitor, extCardNo: extCardNo}
      this.$emit("onGetRecord", record, visitor)

      this.recordDialog = {show: false, hasEnterRecord: false, recordList: [], visitor: null}
    },

    doUsualVisitorEnter(visitor) {
      this.applyDisable = true
      this.visitorDisable = true
      this.extDisable = false
      this.visitor = visitor
      this.visitorForm = {...visitor, extCardNo: visitor.cardNo}
      this.$emit("onGetUsualVisitor", this.visitorForm)
    },

    async getApply(searchObj, visitor) {
      if (searchObj.visitorCardNo) {
        let res = await getApplyLisByGateCardNo(searchObj.visitorCardNo)
        if (res.data.code === 200 && res.data.data.length > 0) {
          return res.data.data.filter(item => {
            return this.curAreaIds.includes(item.entryArea)
          })
        } else {
          return null
        }
      } else if (searchObj.visitorPinCode) {
        let res = await getApplyListByPinCode(searchObj.visitorPinCode)
        if (res.data.code === 200 && res.data.data.length > 0) {
          return res.data.data.filter(item => {
            return this.curAreaIds.includes(item.entryArea)
          })
        } else {
          return null
        }
      } else if (visitor && visitor.code) {
        let res = await getApplyListByVisitCode(visitor.code)
        if (res.data.code === 200 && res.data.data.length > 0) {
          return res.data.data.filter(item => {
            return this.curAreaIds.includes(item.entryArea)
          })
        } else {
          return null
        }
      }
      return null
    },
    getApplyTag(apply) {
      switch (apply.type) {
        case 'BOOK_APPLY':
          return "访客预约"
        case 'INVITE_APPLY':
          return "员工邀约"
        case 'SCENE_APPLY':
          if (apply.device === 'web') {
            return "现场登记"
          } else {
            return "自助登记"
          }
        case 'USUAL':
          return "常访访客"
      }
    },

    onGetApply(validApply, visitor) {
      console.log("onGetApply", validApply, visitor)
      let validApplyList = []
      validApply.forEach(item => {
        let mainVisitor = visitor ? visitor : item.visitor

        validApplyList.push({
          myTag: this.getApplyTag(item),
          myVisitorName: mainVisitor.name,
          myEmployeeName: item.employee.name,
          // myEnterArea: item.entryArea ? this.areaMap[item.entryArea] : "",
          myBeginTime: item.beginDate + " " + item.beginTime.substring(0, 5),
          myEndTime: item.endDate + " " + item.endTime.substring(0, 5),
          myStatus: item.state,
          data: item
        })
      })
      this.applyDialog = {
        show: true,
        applyList: validApplyList,
        visitor: visitor
      }
    },

    doChooseApply(apply) {
      this.isRegister = false
      this.applyDialog.show = false
      this.applyDisable = true
      this.visitorDisable = true
      this.extDisable = false
      this.visitor = apply.pinVisitor ? apply.pinVisitor : apply.visitor

      this.mainVisitor = apply.visitor

      let applyObj = new Apply(apply)
      let formList = applyObj.getShowFormList()
      formList.forEach(item => {
        let find = this.originForms.find(originItem => originItem.title === item.label)
        if (find) {
          this.$set(this.applyForm, find.name, item.value)
        }
      })
      let extCardNo = ""
      if (this.visitor.id === this.mainVisitor.id) {
        extCardNo = apply.visitorCardNo
      } else {
        extCardNo = apply.accompanyCards ? apply.accompanyCards[this.visitor.code] : ""
      }

      this.visitorForm = {...this.visitor, extCardNo: extCardNo ? extCardNo : ""}
      if (this.visitor.id === this.mainVisitor.id) {
        if (this.applyForm.carNumber) {
          this.$set(this.extFormData, "enterCarNum", this.applyForm.carNumber)
        }
      }

      this.applyDialog = {show: false, applyList: [], visitor: null}
      this.$emit("onGetApply", apply, this.visitor)

    },

    handDealFieldDepend() {
      console.log("@@@", this.applyForm)
      this.$nextTick(() => {
        this.forms.forEach(item => {
          if (item.type === 'picker' || item.type === 'address' || item.type === 'list' || item.type === 'reason') {
            this.onSelectChange(item, item.valueListParse, this.applyForm[item.name])
          }
        })
      })
      this.$forceUpdate();
    },
    handleResetFieldDepend() {
      this.$nextTick(() => {
        this.forms.forEach(item => {
          if (item.type === 'picker' || item.type === 'address' || item.type === 'list' || item.type === 'reason') {
            if (item.valueSelect && item.valueSelect.dependField) {
              this.dealDependFieldRemove(item.valueSelect)
            }
          }
        })
      })
      this.$forceUpdate();

    },

    async getHistory(searchObj, visitor) {
      if (!visitor) {
        return null
      }
      let postData = {visitorId: visitor.id, current: 1, size: 1, recordType: "UNIVERSAL"}
      let res = await getRecordList(postData)
      if (res.data.code === 200 && res.data.data && res.data.data.data && res.data.data.data.length > 0) {
        return res.data.data.data[0]
      }
      return null
    },

    onGetHistory(history, visitor) {
      console.log("onGetHistory", history, visitor)
      this.visitor = visitor
      this.visitorForm = {...visitor, extCardNo: ""}
      if (visitor.type === "provider") {
        this.visitorForm.extCardNo = visitor.cardNo
      }
      let recordObj = new Record(history)
      let formList = recordObj.apply.getShowFormList()
      formList.forEach(item => {
        let find = this.originForms.find(originItem => originItem.title === item.label)
        if (find) {
          this.$set(this.applyForm, find.name, item.value)
        }
      })
      let enterCarNum = history.enterCarNum
      if (!enterCarNum) {
        enterCarNum = this.applyForm.carNumber
      }
      this.extFormData.enterCarNum = enterCarNum

      this.$emit("onGetHistory", history, visitor)

      this.$nextTick(() => {
        this.handDealFieldDepend()
      })
    },
    onGetApplyHistory(apply, visitor) {
      console.log("onGetApplyHistory", apply, visitor)
      this.visitor = visitor
      this.visitorForm = {...visitor, extCardNo: ""}
      if (visitor.type === "provider") {
        this.visitorForm.extCardNo = visitor.cardNo
      }
      let applyObj = new Apply(apply)
      let formList = applyObj.getShowFormList()
      formList.forEach(item => {
        let find = this.originForms.find(originItem => originItem.title === item.label)
        if (find) {
          this.$set(this.applyForm, find.name, item.value)
        }
      })

      this.$emit("onGetHistory", apply, visitor)
      this.$nextTick(() => {
        this.handDealFieldDepend()
      })
    },

    onGetNormalVisitor(visitor) {
      this.visitor = visitor
      this.visitorForm = {...visitor, extCardNo: ""}
    },

    async doSearch(searchObj, isAuto) {
      //phoneNo, icCardNo, visitorCardNo, visitorPinCode, visitorSignCode
      let visitor = await this.getVisitor(searchObj)
      console.log("doSearch step 1 visitor", visitor)
      let todayRecord = await this.getRecord(searchObj, visitor)
      console.log("doSearch step 2 todayRecord", todayRecord)
      let enterRecord = todayRecord ? todayRecord.filter(item => item.completeState === "ENTER") : null
      if (enterRecord && enterRecord.length > 0) {
        this.onGetRecord(enterRecord, visitor)
        console.log("doSearch final 1 enterRecord", enterRecord)
        return
      }

      if (visitor && this.checkIsVisitorUsual(visitor)) {

        if (todayRecord != null && todayRecord.length > 0) {
          let find = todayRecord.find(item => item.completeState === "LEAVE" && item.type === "USUAL")
          if (find) {
            await this.$alert(visitor.name + "(常访)已经有签到和签离记录", "提示", {confirmButtonText: "确定"})

            return
          }
        }


        this.doUsualVisitorEnter(visitor)
        console.log("doSearch final 2 usual visitor", visitor)
        return
      }

      let apply = await this.getApply(searchObj, visitor)
      todayRecord = todayRecord ? todayRecord : []
      let validApply = apply ? apply.filter(item => {
        let record = todayRecord.find(record => {
          return record.applyId === item.id
        })
        return record == null
      }) : null
      console.log("doSearch step 3 apply", validApply)
      if (validApply && validApply.length > 0) {
        this.onGetApply(validApply, visitor, todayRecord)
        console.log("doSearch final 3 apply", apply)
        return
      }
      let history = await this.getHistory(searchObj, visitor)
      if (history) {
        this.onGetHistory(history, visitor)
        console.log("doSearch final 4 history", history)
        return
      }

      if (visitor) {
        this.onGetNormalVisitor(visitor)
        console.log("doSearch final 5 visitor", visitor)
        return
      }
      // 1. try to get today record
      // 2. try to get apply
      // 3. try to get history
      // 4. try to get visitor

      if (!isAuto) {
        this.$message.error("搜索失败，未能获到访客信息")
      }
    },


    onReRegister() {
      let recode = this.recordDialog.recordList[0].data
      let visitor = this.recordDialog.visitor ? this.recordDialog.visitor : recode.visitor
      this.onGetHistory(recode, visitor)

      this.recordDialog.show = false
      this.$refs.carKeyboard.clear()
    },

    onReRegisterInApplySelect() {
      let apply = this.applyDialog.applyList[0].data
      let visitor = this.applyDialog.visitor ? this.applyDialog.visitor : apply.visitor
      this.onGetApplyHistory(apply, visitor)

      this.recordDialog.show = false
    },


    reset() {
      this.recordDialog = {show: false, hasEnterRecord: false, recordList: [], visitor: null}
      this.applyDialog = {show: false, applyList: [], visitor: null}
      this.signOutTime = ""
      this.visitor = null
      this.mainVisitor = null
      this.isRegister = true

      this.visitorDisable = false
      this.applyDisable = false
      this.extDisable = false

      this.$nextTick(() => {

        this.$refs.visitorForm.resetFields()
        this.$refs.applyForm.resetFields()
        this.$refs.extForm.resetFields()
        this.$nextTick(() => {
          this.$set(this.visitorForm, "nationality", "中国")
          this.$set(this.extFormData, "visitorNumber", "1")
          if (this.formItemCar) {
            this.$set(this.formItemCar, "value", "")
          }
        })
        this.handleResetFieldDepend()
        this.$nextTick(() => {
          this.$refs.visitorCardNo.focus()
        })
      })

    },

    getFormItremRules(formItem) {
      if (formItem.required === 1 || formItem.extRequired) {
        return [{required: true, message: `${formItem.title}不能为空`}]
      } else {
        return [{required: false}]
      }
    },

    onCarClick() {
      document.activeElement.blur()
      this.carVisible = true
    },

    onCarConfirm(carNo) {
      console.log("onCarConfirm", carNo)
      this.extFormData.enterCarNum = carNo
      this.carVisible = false
    },

    onCarCancel() {
      console.log("onCarCancel")
      this.carVisible = false
    },

    onCarClear() {
      console.log("onCarClear")
      this.extFormData.enterCarNum = ""
    },

  }, // methods
  computed: {
    guardSignList() {
      return this.$store.state.guardSignList
    }
  },
  watch: {
    "visitorForm.tel": function (val) {
      if (this.visitor == null && val.length === 11 && !isNaN(val)) {
        this.searchPhoneNo(val)
      }

    },
    "visitorForm.ic": function (val) {
      if (this.visitor == null && val.length === 18) {
        this.searchIcCardNo(val)
      }
    },
    // "visitorForm.extCardNo": function (val) {
    //   this.extFormData.enterCardNo = val
    // },

    "applyForm.carNumber": function (val) {
      this.extFormData.visitorCardNo = val
      if (this.isRegister) {
        this.extFormData.enterCardNo = val
      }
    },

  }, // watch

  filters: {
    completeStateFilter(value) {
      switch (value) {
        case 'NO':
          return "未到访"
        case 'ENTER':
          return '已到访'
        case 'LEAVE':
          return '已离开'
        default:
          return value
      }
    },
    tableDateFilter(value) {
      switch (value) {
        case 'PASS':
          return "审批通过"
        case 'REJECT':
          return "审批拒绝"
        case 'CANCEL':
          return "审批撤销"
        case 'PROCESS ':
        case 'NONE ':
        default:
          return "审批中"
      }
    },
  }
}
</script>

<template>
  <div class="pt-4 pr-2.5">
    <el-form ref="visitorForm" :model="visitorForm" :rules="visitorRules" label-width="110px" class="main-form" :disabled="visitorDisable">
      <el-form-item label="访客姓名" prop="name" class="w-1/2">
        <el-input v-model="visitorForm.name"></el-input>
      </el-form-item>
      <el-form-item label="访客国籍" prop="nationality" v-if="visitorSetting.nationality !== 1" class="w-1/2">
        <el-input v-model="visitorForm.nationality"></el-input>
      </el-form-item>
      <el-form-item label="访客手机" prop="tel" class="w-1/2 main-item">
        <el-input v-model="visitorForm.tel"></el-input>
      </el-form-item>
      <el-form-item label="访客卡号" prop="extCardNo" class="w-1/2 main-item">
        <el-input v-model="visitorForm.extCardNo" @keydown.enter.native="searchCardNo">
          <el-button slot="append" icon="el-icon-search" @click="searchCardNo"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="ic" v-if="visitorSetting.idCardNo !== 1" class="w-full">
        <el-input v-model="visitorForm.ic"></el-input>
      </el-form-item>
      <el-form-item label="访客公司" prop="company" class="w-full">
        <el-input v-model="visitorForm.company"></el-input>
      </el-form-item>
      <el-form-item label="访客码：" prop="qrCode" class="w-full main-item">
        <el-input v-model="visitorForm.qrCode" ref="visitorCardNo" @keydown.enter.native="searchQrCode">
          <el-button slot="append" icon="el-icon-search" @click="searchQrCode"></el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <el-form ref="applyForm" :model="applyForm" label-width="110px" class="main-form" :disabled="applyDisable">

      <el-form-item v-for="item in forms" :prop="item.name" :label="item.title" :key="item.id" class="w-1/2" :rules="getFormItremRules(item)">

        <el-cascader v-if="item.type === 'myAddress'" class="w-full" clearable
                     v-model="applyForm.myAddress" :options="areaData.areaLeave1">
        </el-cascader>

        <el-input
            v-else-if="item.type === 'input' || item.type === 'company' || item.type === 'comments' "
            class="w-full" v-model="applyForm[item.name]" :disabled="item.extIsReadyOnly">
        </el-input>

        <el-input
            v-else-if="item.type === 'car'  || item.type === 'car_num'"
            readonly @click.native="onCarClick"
            class="table-width-long" v-model="applyForm[item.name]" :disabled="item.extIsReadyOnly">
        </el-input>

        <el-date-picker
            v-else-if="item.type === 'timer'|| item.type === 'beginTime'|| item.type === 'endTime'" type="datetime"
            :editable="false" class="w-full" v-model="applyForm[item.name]">
        </el-date-picker>

        <template v-else-if="item.type === 'file'">
          <el-input class="w-full" disabled v-model="applyForm[item.name]"
                    placeholder="暂不支持"></el-input>
        </template>

        <template v-else-if="item.type === 'number'">
          <el-input class="w-full" v-model="applyForm[item.name]"></el-input>
        </template>

        <template v-else-if="item.type === 'reason'">
          <el-select v-model="applyForm[item.name]" class="w-full"
                     @change="onSelectChange(item, item.valueListParse, applyForm[item.name])" clearable>
            <el-option v-for="child in item.valueListParse" :key="child.value" :label="child.value" :value="child.value">
            </el-option>
          </el-select>
        </template>

        <template
            v-else-if="item.type === 'picker' || item.type === 'address' || item.type === 'list'  || item.type === 'reason' ">
          <el-select v-model="applyForm[item.name]" class="w-full"
                     @change="onSelectChange(item, item.valueListParse, applyForm[item.name])" clearable
                     :disabled="item.extIsReadyOnly">
            <el-option v-for="child in item.valueListParse" :key="child.value" :label="child.value" :value="child.value">
            </el-option>
          </el-select>
        </template>
      </el-form-item>

    </el-form>

    <el-form ref="extForm" :model="extFormData" label-width="110px" class="main-form" :rules="extFormRules" @submit.native.prevent>

      <el-form-item label="来访人数" prop="visitorNumber" class="w-1/2">
        <el-input v-model="extFormData.visitorNumber" class="w-full"></el-input>
      </el-form-item>
      <el-form-item v-if="guardSignShow" label="选择保安" prop="guardSign" class="w-1/2">
        <el-select v-model="extFormData.guardSign" placeholder="请选择保安" filterable clearable>
          <el-option v-for="item in guardSignList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="签到车牌" prop="enterCarNum" class="w-full"   readonly @click.native="onCarClick">
        <el-input v-model="extFormData.enterCarNum" class="w-full" :disabled="extDisable"></el-input>
      </el-form-item>

      <el-form-item label="签到备注" prop="comments" class="w-full">
        <RemarkInputView class="w-full" v-model="extFormData.comments" :disabled="extDisable"></RemarkInputView>
      </el-form-item>
    </el-form>
    <!--    <el-button type="primary" class="w-full" @click="test" >测试</el-button>-->


    <el-dialog :visible.sync="recordDialog.show" title="请选择到访记录并签离" center width="980px">
      <div class=" text-xl font-bold " slot="title">请选择到访记录并签离</div>
      <div class="dialog-container">
        <el-table class="main-table record-table" :data="recordDialog.recordList">
          <el-table-column prop="myTag" label="标签" width="100">
            <template v-slot="scope">
              <el-tag type="danger">{{ scope.row.myTag }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="completeState" label="状态" width="100">
            <template v-slot="scope">
              <el-tag>{{ scope.row.completeState | completeStateFilter }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="myVisitorName" label="访客" width="100"></el-table-column>
          <el-table-column prop="myEmployeeName" label="受访者" width="100"></el-table-column>
          <el-table-column prop="myEnterTime" label="到访时间" width="200"></el-table-column>
          <el-table-column prop="myLeaveTime" label="离开时间" width="200"></el-table-column>
          <el-table-column label="操作" width="100">
            <template v-slot="scope">
              <el-button :disabled="scope.row.completeState !== 'ENTER'" @click="doChooseRecord(scope.row.data)" type="success">
                选择
              </el-button>
            </template>
          </el-table-column>

        </el-table>
        <div class="w-full p-1 flex flex-row justify-center" v-if="!recordDialog.hasEnterRecord">
          <el-button type="primary" @click="onReRegister">重新登记</el-button>
          <el-button @click="reset">返回主页</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="applyDialog.show" title="请选择申请记录并签到" center width="980px">
      <div class=" text-xl font-bold " slot="title">请选择申请记录并签到</div>
      <div class="dialog-container">
        <el-table class="main-table record-table" :data="applyDialog.applyList">
          <el-table-column label="标签" width="100">
            <template v-slot="scope">
              <el-tag type="danger">{{ scope.row.myTag }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="myStatus" label="状态" width="100">
            <template v-slot="scope">
              <el-tag>{{ scope.row.myStatus | tableDateFilter }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="myVisitorName" label="访客" width="100"></el-table-column>
          <el-table-column prop="myEmployeeName" label="受访者" width="100"></el-table-column>
          <!--          <el-table-column prop="myEnterArea" label="到访区域" width="100"></el-table-column>-->
          <el-table-column prop="myBeginTime" label="开始时间" width="200"></el-table-column>
          <el-table-column prop="myEndTime" label="结束时间" width="200"></el-table-column>
          <el-table-column label="操作" width="100">
            <template v-slot="scope">
              <el-button :disabled="scope.row.myStatus !== 'PASS'" @click="doChooseApply(scope.row.data)" type="success">
                选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full p-1 flex flex-row justify-center" v-if="!recordDialog.hasEnterRecord">
          <!--          <el-button type="primary" @click="onReRegisterInApplySelect">重新登记</el-button>-->
          <el-button @click="reset">返回主页</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="车牌号录入" :visible.sync="carVisible" width="80%" center>
      <car-keyboard ref="carKeyboard" :onConfirm="onCarConfirm" :onCancel="onCarCancel" :onClear="onCarClear"></car-keyboard>
    </el-dialog>
  </div>
</template>

<style scoped lang="less">
.main-form {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.main-form {
  /deep/ .el-form-item__label {
    font-size: 20px;
  }

  .el-radio {
    height: 44px;
    line-height: 44px;
  }

  /deep/ .el-radio__label {
    font-size: 20px;
  }

  .el-select {
    width: 100%;
  }

  /deep/ .el-input__inner {
    font-size: 20px;

  }
}

.main-item {
  /deep/ .el-form-item__label {
    color: darkgreen;
    font-weight: bold;
  }
}

.dialog-container {
  max-height: calc(70vh);
  overflow-y: auto;
}

.main-table {
  font-size: 20px;
}

/deep/ .el-table thead {
  font-size: 20px;
  font-weight: normal;
}
</style>
